



































import {
  computed,
  defineComponent,
  getCurrentInstance,
  onBeforeMount,
  onBeforeUnmount,
  ref,
} from "@vue/composition-api";
import { Route } from "vue-router/types/router";
import { UserPublicData } from "@scrile/api-provider/dist/api/UserPublicDataProvider";
import useAuthorisedOnly from "@/hooks/useAuthorisedOnly";
import emitter from "@/lib/emitter";
import { $t } from "@/lib/i18nHelpers";
import { getLiveUrl } from "@/lib/urlHelpers";
import { EVENTS } from "@/const";
import BaseAvatar from "@/components/BaseAvatar";
import BaseConfirm from "@/components/BaseConfirm";
import UserFollowSubscribeModal from "@/components/UserFollowSubscribeModal";

export default defineComponent({
  name: "ModalFollowSubscribe",
  components: { BaseAvatar, BaseConfirm, UserFollowSubscribeModal },
  setup(_, { root }) {
    const vm = getCurrentInstance();
    const show = ref(false);
    const showDialog = ref(true);
    const needFollow = ref(false);
    const prevRoute = ref<Route | null>(null);
    const liveUser = ref<UserPublicData | null>(null);
    const modalText = ref("");
    const modalAppendText = ref("");
    const modalTitle = ref("");

    const showModal = ({
      user,
      text,
      appendText,
      title,
      follow,
    }: {
      user: UserPublicData;
      text: string;
      appendText?: string;
      title?: string;
      follow?: boolean;
    }) => {
      if (!user) {
        return;
      }
      needFollow.value = follow ? follow : false;
      modalTitle.value = title ? title : $t("Choose subscription");
      modalAppendText.value = appendText ? appendText : "";
      liveUser.value = user;
      modalText.value = text;
      show.value = true;
    };
    const hideModal = () => {
      show.value = false;
      if (prevRoute.value) vm?.$router.push({ path: prevRoute.value.path });
    };

    onBeforeMount(() => {
      emitter.on<any>(EVENTS.FOLLOW_SUBSCRIBE_SHOW, showModal);
      emitter.on<any>(EVENTS.FOLLOW_SUBSCRIBE_HIDE, hideModal);
    });

    onBeforeUnmount(() => {
      emitter.off<any>(EVENTS.FOLLOW_SUBSCRIBE_SHOW, showModal);
      emitter.off<any>(EVENTS.FOLLOW_SUBSCRIBE_HIDE, hideModal);
    });

    vm?.$router.beforeEach((to, from, next) => {
      prevRoute.value = from;
      next();
    });

    const updateStatus = async (status: boolean) => {
      emitter.emit(EVENTS.FOLLOW_STATUS_UPDATE, status);
      if (status && liveUser.value && prevRoute.value && prevRoute.value.name === getLiveUrl(liveUser.value).name) {
        root.$router.push(getLiveUrl(liveUser.value));
      }
    };

    const onClose = async () => {
      showDialog.value = true;
      hideModal();
    };

    const onFollowSubscribe = computed(() =>
      useAuthorisedOnly(async () => (showDialog.value = false), (liveUser.value && liveUser.value.id) || "")
    );

    return {
      show,
      showDialog,
      liveUser,
      needFollow,
      onFollowSubscribe,
      onClose,
      hideModal,
      updateStatus,
      modalText,
      modalAppendText,
      modalTitle,
    };
  },
});
